import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, PLATFORM_ID, inject } from '@angular/core';
import { LangChangeEvent, TranslateService, TranslatePipe } from '@ngx-translate/core';

import { MbRouterLinkDirective } from '@modules/shared/directives/mb-router-link.directive';
import { LocaleService } from '@modules/shared/services/locale.service';
import { languageConfig, Locale } from 'src/environments/language.config';

@Component({
  selector: 'mb-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, MbRouterLinkDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FooterComponent {
  translateService = inject(TranslateService);
  private localeService = inject(LocaleService);
  private platformId = inject(PLATFORM_ID);

  public currentLanguage: string;

  public languages = languageConfig.languages.map((isoLang) => ({
    isoLang,
    label: isoLang.split('-')[0].toUpperCase(),
  }));

  constructor() {
    this.currentLanguage = this.translateService.currentLang() ?? Locale.DE;
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang;
    });
  }

  get showCCPALink() {
    return this.translateService.currentLang() === Locale.EN;
  }

  get isBrowser() {
    return isPlatformBrowser(this.platformId);
  }

  get supportUrl() {
    const subject = this.translateService.instant('FOOTER.SUPPORT.SUBJECT');
    return new URL(`mailto:mb.media.support@appsfactory.de?subject=${subject}`).toString();
  }

  public changeLanguage(language: string): void {
    this.localeService.changeLanguage(language);
  }
}
